import axios from 'axios';
import { setAlert } from './alert';
import {
    GET_SPAREPART_IMPORTS_LIST_LOADING,
    GET_SPAREPART_IMPORTS_LIST,
    GET_SPAREPART_IMPORTS_LIST_ERROR,
    GET_SPAREPART_IMPORT,
    ADD_SPAREPART_IMPORT_ITEM,
    ADD_SPAREPART_IMPORT_ITEM_ERROR,
    UPDATE_SPAREPART_IMPORT_ITEM,
    UPDATE_SPAREPART_IMPORT_ITEM_ERROR,
    DELETE_SPAREPART_IMPORT_ITEM,
    DELETE_SPAREPART_IMPORT_ITEM_ERROR,
    SET_DELETE_SPAREPART_IMPORT_ITEM_ID,
    SET_UPDATE_SPAREPART_IMPORT_ITEM_ID,
    GET_SPAREPART_IMPORTS_COUNT,
    GET_SPAREPART_IMPORTS_COUNT_ERROR
} from './types';

// Get sparepart imports
export const getSparepartImports = (page = 1, filters = {}) => async dispatch => {
    try {
        // Set loading state
        dispatch({
            type: GET_SPAREPART_IMPORTS_LIST_LOADING
        });

        // Ensure we have a per_page parameter
        if (!filters.per_page) {
            filters.per_page = 10;
        }
        
        // Build query string from filters
        const queryParams = new URLSearchParams();
        queryParams.append('page', page);
        
        Object.keys(filters).forEach(key => {
            queryParams.append(key, filters[key]);
        });
        
        const url = `/sparepart-imports?${queryParams.toString()}`;
        console.log('Making API call to:', url);
        console.log('Filters being sent:', filters);
        
        const res = await axios.get(url);
        
        dispatch({
            type: GET_SPAREPART_IMPORTS_LIST,
            payload: res.data
        });
    } catch (err) {
        dispatch({
            type: GET_SPAREPART_IMPORTS_LIST_ERROR,
            payload: { msg: err.response?.data?.message || 'Server Error', status: err.response?.status }
        });
    }
};

// Get sparepart imports count
export const getSparepartImportsCount = (filters = {}) => async dispatch => {
    try {
        const params = new URLSearchParams(filters).toString();
        const res = await axios.get(`/sparepart-imports/count?${params}`);
        
        dispatch({
            type: GET_SPAREPART_IMPORTS_COUNT,
            payload: res.data
        });
    } catch (err) {
        dispatch({
            type: GET_SPAREPART_IMPORTS_COUNT_ERROR,
            payload: { msg: err.response?.data?.message || 'Server Error', status: err.response?.status }
        });
    }
};

// Get single sparepart import for editing
export const getSparepartImport = (id) => async dispatch => {
    try {
        const res = await axios.get(`/sparepart-imports/${id}`);
        
        dispatch({
            type: GET_SPAREPART_IMPORT,
            payload: res.data,
        });
        
        return res.data;
    } catch (err) {
        dispatch(setAlert('Ehtiyot qism importini yuklashda xatolik', 'danger'));
        throw err;
    }
};

// Create sparepart import
export const createSparepartImport = formData => async dispatch => {
    try {
        const res = await axios.post('/sparepart-imports', formData);

        dispatch({
            type: ADD_SPAREPART_IMPORT_ITEM,
            payload: res.data
        });

        dispatch(setAlert('Ehtiyot qism importi muvaffaqiyatli yaratildi', 'success'));
    } catch (err) {
        dispatch({
            type: ADD_SPAREPART_IMPORT_ITEM_ERROR,
            payload: { msg: err.response?.data?.message || 'Server Error', status: err.response?.status }
        });

        dispatch(setAlert('Ehtiyot qism importini yaratishda xatolik', 'danger'));
    }
};

// Update sparepart import
export const updateSparepartImport = (id, formData) => async dispatch => {
    try {
        const res = await axios.put(`/sparepart-imports/${id}`, formData);

        dispatch({
            type: UPDATE_SPAREPART_IMPORT_ITEM,
            payload: res.data
        });

        dispatch(setAlert('Ehtiyot qism importi muvaffaqiyatli yangilandi', 'success'));
    } catch (err) {
        dispatch({
            type: UPDATE_SPAREPART_IMPORT_ITEM_ERROR,
            payload: { msg: err.response?.data?.message || 'Server Error', status: err.response?.status }
        });

        dispatch(setAlert('Ehtiyot qism importini yangilashda xatolik', 'danger'));
    }
};

// Delete sparepart import
export const deleteSparepartImport = (id, currentPage = 1) => async dispatch => {
    try {
        await axios.delete(`/sparepart-imports/${id}`);

        dispatch({
            type: DELETE_SPAREPART_IMPORT_ITEM,
            payload: id
        });

        dispatch(setAlert('Ehtiyot qism importi muvaffaqiyatli o\'chirildi', 'success'));
        
        // Refresh the list after deletion
        dispatch(getSparepartImports(currentPage));
        
        return true;
    } catch (err) {
        dispatch({
            type: DELETE_SPAREPART_IMPORT_ITEM_ERROR,
            payload: { msg: err.response?.data?.message || 'Server Error', status: err.response?.status }
        });

        dispatch(setAlert('Ehtiyot qism importini o\'chirishda xatolik', 'danger'));
        return false;
    }
};

// Set delete sparepart import id
export const setDeleteSparepartImportId = id => dispatch => {
    dispatch({
        type: SET_DELETE_SPAREPART_IMPORT_ITEM_ID,
        payload: id
    });
};

// Set update sparepart import id
export const setUpdateSparepartImportId = id => dispatch => {
    dispatch({
        type: SET_UPDATE_SPAREPART_IMPORT_ITEM_ID,
        payload: id
    });
};

// Download sparepart import document
export const downloadSparepartImportDocument = (importId, textColor = '#000000') => async (dispatch) => {
    try {
        const response = await axios.get(`/sparepart-imports/${importId}/download_document`, {
            params: { text_color: textColor }
        });
        return response.data;
    } catch (err) {
        dispatch(setAlert("Yuklashda muommo bo'ldi!", 'danger'));
        throw err;
    }
};

 